import React from 'react';
import Header from './../components/Primary/Header'
import Footer from './../components/Primary/Footer'

const MainLayout =({children}) =>{
    return(
        <>
        
        <Header />
        
        <div className="md:px-8 md:py-4 px-2  md:mb-0 font-poppins ">

            {children}
            
        </div>
        <Footer />
        </>
    )
}

export default MainLayout;